import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { Size, LogGroup, Scale, Point, CreateElement, CreateSpineResources } from "../../MyHelpers";
import { ISpinnableReels } from "../SpinAnimation/SpinnableReels";
import { GenericPlusOne, GenericPlusOnePIXIAPP, PlusOneParams } from "./GenericPlusOneAnimation";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { Sprite } from "../Sprite/Sprite";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { TimelineLite, TimelineMax, TweenMax, Power0 } from "gsap";
import { TimelineMaxEx } from "../TimelineLiteWithAddDelay";
import { Container, DisplayObject, RenderTexturePool } from "pixi.js";
import { PlusOnePosition } from "./FreegamePlusOne";
import { SpritePlusOneComplete, FreegameSpritePlusOneComplete } from "./SpritePlusOneAnimation";
import * as PIXI from "pixi.js"
import { Settings } from "../../Settings";
import gsap from 'gsap';
import { DecodedImageResource, ImageResource } from "../../ResourceManager/ImageResource";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import { ISkeletonData, Spine } from "pixi-spine";
//import { PixiPlugin } from "gsap/src/PixiPlugin";

//gsap.registerPlugin(PixiPlugin);
// export interface PlusOnePosition {
// 	Reel: number;
// 	Row: number;
// }

//export type SpritePlusOneComplete = (index: number) => void;
export class FreegameSpritePlusOneElementPIXIAPP {
	//protected index: number;
	//protected view: HTMLElement;
	//protected spr: SpriteResource;
	protected symbolSize: Size;
	//protected sprSprite: Sprite;
	//protected sprcanvas: CanvasSprite;



	protected startPosition: Point = null;
	protected endPosition: Point = null;
	//public commonResourcesBasePath: string;

	//protected anim: gsap.core.Timeline = null;


	protected viewPIXIAPP: PIXI.Container = null;


	public constructor() {
		//this.index = index;		
		//this.symbolSize = symbolSize;
		// this.viewPIXIAPP = new PIXI.Container();
		// this.viewPIXIAPP.name = "PlusOne-" + index;
		// this.viewPIXIAPP.x = 0;
		// this.viewPIXIAPP.y = 0;
		// this.viewPIXIAPP.visible = false;
		// this.viewPIXIAPP.width = this.symbolSize.width;
		// this.viewPIXIAPP.height = this.symbolSize.height;
		// this.viewPIXIAPP.pivot.set(this.symbolSize.width/2,this.symbolSize.height/2);

		// //console.log("PLUSONeTEXTURe:",spr);
		// let viewTexture = new PIXI.AnimatedSprite(spr);		
		// viewTexture.width = this.symbolSize.width;
		// viewTexture.height = this.symbolSize.height;

		// this.viewPIXIAPP.addChild(viewTexture);			



	}

	protected spine: Spine = null;
	public CreatePIXAPP(index: number, symbolSize: Size, jsonSpine: ISkeletonData) {
		this.symbolSize = symbolSize;
		this.viewPIXIAPP = new PIXI.Container();
		this.viewPIXIAPP.name = "PlusOne-" + index;
		this.viewPIXIAPP.x = 0;
		this.viewPIXIAPP.y = 0;
		//this.viewPIXIAPP.visible = false;
		this.viewPIXIAPP.width = symbolSize.Width;
		this.viewPIXIAPP.height = symbolSize.Height;
		// this.viewPIXIAPP.pivot.set(symbolSize.Width / 2, symbolSize.Height / 2);

		// //console.log("PLUSONeTEXTURe:",spr);
		// let viewTexture = new PIXI.AnimatedSprite(spr);		
		// viewTexture.width = symbolSize.width;
		// viewTexture.height = symbolSize.height;

		this.spine = CreateSpineResources(jsonSpine);
		//this.spine.scale.set(Scale.H(0.5), Scale.W(0.5));
		//this.spine.state.timeScale = 1;
		this.viewPIXIAPP.addChild(this.spine);
	}


	public SetPosition(startPosition: Point, endPosition: Point): void {
		this.startPosition = startPosition;
		this.endPosition = endPosition;

		this.viewPIXIAPP.x = this.startPosition.x;
		this.viewPIXIAPP.y = this.startPosition.y;

		console.log("SetPosition Start:", this.startPosition);
		console.log("SetPosition End:", this.endPosition);
	}

	protected globalTarget: Point = null;
	public SetGlobalTarget(target: Point): void {
		this.globalTarget = target;
		this.endPosition = this.viewPIXIAPP.parent.toLocal(target);

		console.log("SetGlobalTarget global:", this.globalTarget);
		console.log("SetGlobalTarget End:", this.endPosition);
	}

	public Move(pos: Point): void {
		this.viewPIXIAPP.x = pos.x;
		this.viewPIXIAPP.y = pos.y;

		console.log("Move:", pos);

	}

	public MoveGlobal(pos: Point): void {
		const local = this.viewPIXIAPP.parent.toLocal(pos);
		this.viewPIXIAPP.x = local.x;
		this.viewPIXIAPP.y = local.y;

		console.log("MoveGlobal:", pos);

	}

	public View(): HTMLElement {
		return null;
	}

	public Show() {
		this.viewPIXIAPP.visible = true;
		this.spine.visible = true;
		let animShow = this.spine.state.setAnimation(0, "show", false);
	}

	public Start() {
		//this.viewPIXIAPP.visible = true;
		this.viewPIXIAPP.x = this.startPosition.x;
		this.viewPIXIAPP.y = this.startPosition.y;
		let animShow = this.spine.state.setAnimation(0, "show", false);
		let anim = gsap.timeline({ paused: true, });

		this.spine.visible = true;

		let spinePropieties = {
			// scaleX: 0.5,
			// scaleY: 0.5,
			x: this.startPosition.x,
			y: this.startPosition.y,
		}

		setTimeout(() => {
			this.spine.state.setAnimation(0, "loop", true);
		}, animShow.animationEnd * 1000);

		anim.to(
			spinePropieties,
			{
				//duration: 2100 / 1000,
				delay: 1.5, 
				onUpdate: () => {
					this.viewPIXIAPP.x = spinePropieties.x;
					this.viewPIXIAPP.y = spinePropieties.y;
					// this.viewPIXIAPP.scale.set(spinePropieties.scaleX, spinePropieties.scaleY);
				}, 
				// scaleX: 0.5, 
				// scaleY: 0.5, 
				x: this.endPosition.x, 
				y: this.endPosition.y, 
				ease: Power0.easeNone, 
				onComplete: () => {
					this.Complete();
				}
			});
		anim.play();
	}

	protected onCompleteCallback: SpritePlusOneCompletePIXIAPP = null;
	public OnComplete(callback: SpritePlusOneCompletePIXIAPP): void {
		this.onCompleteCallback = callback;
	}

	protected Complete(): void {
		//this.viewPIXIAPP.visible = false;		
		this.spine.visible = false;
		this.spine?.state?.clearTracks();
		this.spine?.skeleton?.setBonesToSetupPose();
		this.spine?.skeleton?.setToSetupPose();
		this.spine?.skeleton?.setSlotsToSetupPose();
		this.spine?.state?.update(0);
		this.spine?.update(0);
		// this.viewPIXIAPP.scale.set(1);

		// if (this.onCompleteCallback != null) {
		// 	//this.spine.state.clearTracks();			

		// 	this.onCompleteCallback();
		// }
	}
	public Update() {
		//this.sprcanvas.Update();
	}
	public ViewPIXIAPP(): PIXI.Container {
		return this.viewPIXIAPP;
	}
}

export type SpritePlusOneCompletePIXIAPP = () => void;

//export type FreegameSpritePlusOneComplete = () => void;
export class FreegameSpritePlusOnePIXIAPP extends GenericPlusOnePIXIAPP {
	public override SetGlobalTarget(target: Point): void {
		this.plusOne.SetGlobalTarget(target);
	}
	/** size of the whole screen. This animation will use whole screen, because it must go to the top edge */
	protected viewSize: Size;

	/** for location of symbols on reels */
	protected spinnableReels: ISpinnableReels;

	/** image to draw as an +1 element, when it animates */
	//protected spr: SpriteResource;

	/** size of single symbol in reel, to center the +1 over it */
	protected symbolSize: Size;

	/** container view element */
	//protected view: HTMLElement;

	/** all available element to animate. We don't delete those, they act as cache and stay created forever */
	//protected elements: FreegameSpritePlusOneElementPIXIAPP[] = [];

	/** last set of symbols that triggered +1 */
	protected symbols: PlusOnePosition[] = null;

	/** number of element animations that completed since last start. Used for detecting when all animations have finished */
	protected animationsComplete: number = 0;

	protected duration: number = 2100;
	protected logGroup: LogGroup;
	//protected sprCanvas: CanvasSprite;
	protected resid: ResourceIdentifier;
	protected bonusName: string;
	protected countFreeGames: number = 0;
	protected maxAdditionalFreegames: number = 0;
	protected viewPIXIAPP: PIXI.Container = null;
	protected gameBonusResourcesBasePath: string = null;
	protected commonBonusResourcesBasePath: string = null;


	public constructor(params: PlusOneParams) {
		super()
		this.viewSize = params.viewSize;
		this.spinnableReels = params.spinnableReels;
		this.logGroup = params.logGroup.Add("SpritePlusOne");
		this.resid = params.resid;
		//this.spr = spr;
		this.bonusName = params.bonusName;

		this.symbolSize = params.spinnableReels.GetSymbolSize();

		this.maxAdditionalFreegames = params.maxAdditionalFreegames;
		this.gameBonusResourcesBasePath = params.gameBonusResourcesBasePath;
		this.commonBonusResourcesBasePath = params.commonBonusResourcesBasePath;

		// //create pixi vew 
		// this.viewPIXIAPP = new PIXI.Container();
		// this.viewPIXIAPP.name = "FreegamePlusOnePIXIAPP-SpritePlusOne";
		// this.viewPIXIAPP.width = this.viewSize.width;
		// this.viewPIXIAPP.height = this.viewSize.height;
		// this.viewPIXIAPP.y = Settings.ScreenHeight * (Settings.Screens - 1);		
		// this.viewPIXIAPP.interactive = false;
		// this.viewPIXIAPP.interactiveChildren = false;

		let command: string = "";
		window.addEventListener('keydown', (e) => {
			command += e.key.toLowerCase();

			if (command.endsWith("porun")) {
				this.plusOne.Start();
			}
			else if (command.endsWith("poshow")) {
				this.plusOne.Show();
			}
			else if (command.endsWith("popos")) {
				let startPoint = this.spinnableReels.GetAbsoluteSymbolRectReelRow(this.startSymbols.Reel, this.startSymbols.Row).Center()
				this.plusOne.SetPosition(startPoint, this.startTarget);
			}
			else if (command.endsWith("postart")) {
				let startPoint = this.spinnableReels.GetAbsoluteSymbolRectReelRow(this.startSymbols.Reel, this.startSymbols.Row).Center()
				this.plusOne.Move(startPoint);
			}
			else if (command.endsWith("poend")) {
				this.plusOne.Move(this.startTarget);
			}
			else if (command.endsWith("pogend")) {
				this.plusOne.MoveGlobal(this.startTarget);
			}
		});
	}

	public Name(): String {
		return "SpritePlusOne";
	}


	public PrepareResources(resourceManager: IWriteOnlyResourceManager) {
		//Title Prepare 				
		resourceManager.Add(new JSONResource(`${this.commonBonusResourcesBasePath}resources/SpineResources/PlusOne/PlusOne.json`, this.resid.ScopedResourceName(`PlusOneSpineJson`)));
		resourceManager.Add(new AtlasResource(`${this.commonBonusResourcesBasePath}resources/SpineResources/PlusOne/PlusOne.atlas`, this.resid.ScopedResourceName(`PlusOneSpineATLAS`)));
	}

	protected texturePlusOne: PIXI.Texture[] = [];
	protected jsonSpine: ISkeletonData = null;
	protected plusOne: FreegameSpritePlusOneElementPIXIAPP = null;
	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {


		let plusonejson = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`PlusOneSpineJson`));
		let plusonejsonspine = await PIXI.Assets.load(plusonejson.path)
		this.jsonSpine = plusonejsonspine.spineData;

		this.plusOne = new FreegameSpritePlusOneElementPIXIAPP();
	}


	public IsPending(): boolean {
		return true;
	}

	protected jumpAnim: boolean = false;
	/** just starts the animation */
	protected startSymbols: PlusOnePosition = null;
	protected startTarget: Point = null;
	public Start(symbols: PlusOnePosition[], target: Point): void {

		this.animationsComplete = 0;

		//this.symbols = symbols;


		// // precreate elements
		// if (this.elements.length < symbols.length) {
		// 	for (let i = this.elements.length; i < symbols.length; i++) {
		// 		let plus: FreegameSpritePlusOneElementPIXIAPP = new FreegameSpritePlusOneElementPIXIAPP(i, this.texturePlusOne, this.symbolSize);
		// 		this.elements.push(plus);
		// 		//this.view.appendChild(plus.View());
		// 		this.viewPIXIAPP.addChild(plus.ViewPIXIAPP());
		// 	}
		// }

		//this.countFreeGames = 0;		

		//for (let i = 0; i < symbols.length; i++) {		
		this.countFreeGames++;
		if (this.countFreeGames <= this.maxAdditionalFreegames) {
			let startPoint = this.spinnableReels.GetAbsoluteSymbolRectReelRow(symbols[0].Reel, symbols[0].Row).Center();

			this.plusOne.SetPosition(startPoint, null);
			this.plusOne.SetGlobalTarget(target);
			this.plusOne.Start();
			this.plusOne.Show();
			globalThis.plusOne = this.plusOne;
			console.log("CountPlusone:", this.countFreeGames);
		}
		// else {
		// 	//this.jumpAnim = true;
		// 	console.log("CountPlusoneJump:", true);
		// 	//break
		// }
		//}
		//this.countFreeGames = 0;

		// finaly start animations

		//for (let i = 0; i < symbols.length; i++) {				
		//if (i <= this.maxAdditionalFreegames)

		//}
	}

	public StartPlusOnePIXIAPP(symbols: PlusOnePosition, target: Point): void {
		this.startSymbols = symbols;
		this.startTarget = target;

		this.animationsComplete = 0;
		this.countFreeGames++;
		if (this.countFreeGames <= this.maxAdditionalFreegames) {
			let startPoint = this.spinnableReels.GetAbsoluteSymbolRectReelRow(symbols.Reel, symbols.Row).Center();
			this.plusOne.SetPosition(startPoint, null);
			this.plusOne.SetGlobalTarget(target);
			this.plusOne.Start();
			this.plusOne.Show();

			globalThis.plusOne = this.plusOne;
			console.log("CountPlusone:", this.countFreeGames);
		}
	}

	public Duration(): number {
		return this.duration;
	}

	/** single element has finished its animation */
	// protected ElementComplete(index: number): void {
	// 	this.animationsComplete++;

	// 	// when all elements are finished, the whole animation is finished
	// 	if (this.animationsComplete == this.symbols.length) {
	// 		this.Complete();
	// 	}
	// }

	/** returns view element */
	public View(): HTMLElement {
		return null;
	}

	protected completeCallback: FreegameSpritePlusOneComplete = null;

	/** set callback for when all elements are complete with animation */
	public OnComplete(callback: FreegameSpritePlusOneComplete): void {
		this.completeCallback = callback;
	}

	/** called when all elements are complete with animation */
	protected Complete(): void {
		if (this.completeCallback != null) {
			this.completeCallback();
		}
	}
	public Update() {
		this.plusOne.Update();
	}
	public ResetCount() {
		this.countFreeGames = 0;
		//this.jumpAnim = false;
	}

	public WillStartAnim(): boolean {
		if (this.countFreeGames < this.maxAdditionalFreegames) {
			return true
		}
		else {
			return false
		}
		//return this.jumpAnim;
	}

	public override ViewPIXIAPP(): Container<DisplayObject> {
		return this.viewPIXIAPP;
	}

	public override CreatePIXAPP(): PIXI.Container {

		//create pixi vew 
		this.viewPIXIAPP = new PIXI.Container();
		this.viewPIXIAPP.name = "FreegamePlusOnePIXIAPP-SpritePlusOne";
		this.viewPIXIAPP.width = this.viewSize.Width;
		this.viewPIXIAPP.height = this.viewSize.Height;
		//this.viewPIXIAPP.y = Settings.ScreenHeight * (Settings.Screens - 1);
		this.viewPIXIAPP.interactive = false;
		this.viewPIXIAPP.interactiveChildren = false;


		//this.view.appendChild(plus.View());
		this.plusOne.CreatePIXAPP(0, this.symbolSize, this.jsonSpine);
		this.viewPIXIAPP.addChild(this.plusOne.ViewPIXIAPP());

		return this.viewPIXIAPP

	}
}

export class FreegameSpritePlusOnePIXIAPPResponsive extends FreegameSpritePlusOnePIXIAPP {

	// public override StartPlusOnePIXIAPP(symbols: PlusOnePosition, target: Point): void {

	// 	this.startSymbols = symbols;
	// 	this.startTarget = target;

	// 	this.animationsComplete = 0;
	// 	this.countFreeGames++;
	// 	if (this.countFreeGames <= this.maxAdditionalFreegames) {
	// 		let startPoint = this.spinnableReels.GetAbsoluteSymbolRectReelRow(symbols.Reel, symbols.Row).Center();
	// 		this.plusOne.SetPosition(startPoint, target);
	// 		this.plusOne.SetGlobalTarget(target);
	// 		// this.plusOne.Start();
	// 		this.plusOne.Show();

	// 		globalThis.plusOne = this.plusOne;
	// 		console.log("CountPlusone:", this.countFreeGames);
	// 	}
	// }

}
